<form [formGroup]="formGroup" class="bg-white">
  <div class="development-title !text-[#21252A] !pl-[36px] sticky top-0 !z-50">
    Pre-Qualification Questionnaire (PQQ)
    <span class="comapny-general-info">
      Financial and Insurance Information </span
    >
  </div>

  <div class="container p-5 !pt-0 !pb-0">
    <!-- Financial and Insurance Information  -->
    <div #container_wrapper id="container_wrapper" class="container_wrapper">
      <ng-container class="float-left">
        <div
          class="container-fluid flex !justify-left h-auto p-[29px] !pl-[13px] !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
        >
          <div
            class="!p-[30px] !pl-0 !justify-start !pb-0 !bg-[#ffffff] w-full !pt-[0px]"
          >
            <h3
              class="!text-[20px] !font-semibold !text-[#21252A] !mb-[0px] !pt-0 !pb-[22px]"
            >
              Financial Information
            </h3>

            <label> Last Year Annual Turn Over </label>
            <div
              class="!mt-5 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-[10rem] container"
            >
              <div class="container p-5 !pl-0 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded pl-0 p-10 !pb-0 !pt-0">
                  <mat-form-field
                    class="lg:!w-[25.683vw] md:w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>Financial Year</mat-label>
                    <mat-select
                      formControlName="annual_turnover_last_year_date"
                      placeholder="Select Year"
                    >
                      <mat-option *ngFor="let year of years" [value]="year">{{
                        year
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="container p-5 !pl-0 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded pl-0 p-10 !pb-0 !pt-0">
                  <mat-form-field
                    class="lg:!w-[25.683vw] md:w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Annual Turnover </mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="annual_turnover_last_year_value"
                      placeholder=" Annual Turnover"
                      currencyMask
                      [options]="{
                        prefix: currencySymbol ? currencySymbol : '$',
                        thousands: ',',
                        decimal: '',
                        nullable: true,
                        allowZero: false,
                        precision: 0,
                        max: 100000000000,
                      }"
                    />
                  </mat-form-field>
                </div>
                <div class="mt-[15px] justify-items-center">
                  <span class="w-full text-[12px] mt-[8px]">
                    {{
                      numberToWords(
                        formGroup.get("annual_turnover_last_year_value")?.value
                      ) | titlecase
                    }}
                  </span>
                </div>
              </div>
            </div>

            <label> Second Last Year Annual Turn Over </label>
            <div
              class="!mt-5 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-[10rem] container"
            >
              <div class="container p-5 !pl-0 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded pl-0 p-10 !pb-0 !pt-0">
                  <mat-form-field
                    class="lg:!w-[25.683vw] md:w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>Financial Year</mat-label>
                    <mat-select
                      formControlName="annual_turnover_last_2_year_date"
                      placeholder="Select Year"
                    >
                      <mat-option *ngFor="let year of years" [value]="year">{{
                        year
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="container p-5 !pl-0 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded pl-0 p-10 !pb-0 !pt-0">
                  <mat-form-field
                    class="lg:!w-[25.683vw] md:w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Annual Turnover </mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="annual_turnover_last_2_year_value"
                      placeholder=" Annual Turnover"
                      currencyMask
                      [options]="{
                        prefix: currencySymbol ? currencySymbol : '$',
                        thousands: ',',
                        decimal: '',
                        nullable: true,
                        allowZero: false,
                        precision: 0,
                        max: 100000000000,
                      }"
                    />
                  </mat-form-field>
                </div>
                <div class="mt-[15px] justify-items-center">
                  <span class="w-full text-[12px] mt-[8px]">
                    {{
                      numberToWords(
                        formGroup.get("annual_turnover_last_2_year_value")
                          ?.value
                      ) | titlecase
                    }}
                  </span>
                </div>
              </div>
            </div>

            <label> Third Last Year Annual Turn Over </label>
            <div
              class="!mt-5 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-[10rem] container"
            >
              <div class="container p-5 !pl-0 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded pl-0 p-10 !pb-0 !pt-0">
                  <mat-form-field
                    class="lg:!w-[25.683vw] md:w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>Financial Year</mat-label>
                    <mat-select
                      formControlName="annual_turnover_last_3_year_date"
                      placeholder="Select Year"
                    >
                      <mat-option *ngFor="let year of years" [value]="year">{{
                        year
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="container p-5 !pl-0 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded pl-0 p-10 !pb-0 !pt-0">
                  <mat-form-field
                    class="lg:!w-[25.683vw] md:w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Annual Turnover </mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="annual_turnover_last_3_year_value"
                      placeholder=" Annual Turnover"
                      currencyMask
                      [options]="{
                        prefix: currencySymbol ? currencySymbol : '$',
                        thousands: ',',
                        decimal: '',
                        nullable: true,
                        allowZero: false,
                        precision: 0,
                        max: 100000000000,
                      }"
                    />
                  </mat-form-field>
                </div>
                <div class="mt-[15px] justify-items-center">
                  <span class="w-full text-[12px] mt-[8px]">
                    {{
                      numberToWords(
                        formGroup.get("annual_turnover_last_3_year_value")
                          ?.value
                      ) | titlecase
                    }}
                  </span>
                </div>
              </div>
            </div>

            <div
              class="grid-cols-1 md:grid-cols-1 lg:grid-cols-1  container"
            >
              <div class="container p-0 !pt-0 !pb-0 !pr-[4rem]">
                <div class="rounded !pl-0 p-10 !pb-0 !pt-0">
                  <div
                    class="!p-10 !pl-0 !pb-0 !pt-0 flex !text-[#21252A] items-center !max-w-[1195px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1"
                  >
                    <label>
                      Provide a copy of your most recent audited financial
                      accounts.
                    </label>
                    <div class="bg-[#FFFFFF]  ">
                      <div
                        class="flex !w-full h-[122px] mt-2 flex-col bg-[#f7f6fb] items-center justify-center p-6 border-2 mr-[25px] border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-gray-100"
                      >
                        <button
                          type="button"
                          class="bg-[#D9D9D9] text-[#343A40] px-4 py-2 rounded focus:outline-none"
                          (click)="fileInputDocument.click()"
                        >
                          Attach File
                        </button>
                        <p
                          class="!text-[14px] pt-[5px] !font-medium !m-0 !text-[#21252A]"
                        >
                          Drag & Drop
                        </p>
                        <input
                          type="file"
                          multiple
                          #fileInputDocument
                          (change)="
                            onFileUpload($event, 'fin_recent_audit_attach')
                          "
                          hidden
                        />
                      </div>
                    </div>

                    <!-- Old attachments -->

                    <div
                      class="flex flex-col"
                      *ngFor="
                        let file of oldFinRecentAuditAttach;
                        let i = index
                      "
                    >
                      <div class="flex items-start mt-[11px]">
                        <div class="flex justify-start items-center">
                          <div
                            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
                          >
                            <img
                              [src]="getFileIcon(file)"
                              alt="File Preview"
                              class="object-cover w-auto h-[100%] cursor-pointer"
                            />
                          </div>
                        </div>

                        <span
                          style="
                            color: black;
                            text-align: left;
                            font-size: 18px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            display: inline-block;
                            overflow: visible;
                            margin-left: 10px;
                            margin-top: 5px;
                          "
                        >
                          {{ file.title }}
                        </span>

                        <img
                          src="assets/icons/trash.svg"
                          alt="trash"
                          class="object-cover w-auto cursor-pointer ml-[8px] !h-[13px] mt-[11px]"
                          (click)="
                            removeOldFile(i, file.id, 'fin_recent_audit_attach')
                          "
                        />
                      </div>
                    </div>
                    <!-- New attachments -->

                    <div
                      class="flex flex-col"
                      *ngFor="let file of finRecentAuditAttach; let i = index"
                    >
                      <div class="flex items-start mt-[11px]">
                        <div class="flex justify-start items-center">
                          <div
                            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
                          >
                            <img
                              [src]="getFileIcon(file)"
                              alt="File Preview"
                              class="object-cover w-auto h-[100%] cursor-pointer"
                            />
                          </div>
                        </div>

                        <span
                          style="
                            color: black;
                            text-align: left;
                            font-size: 18px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            display: inline-block;
                            overflow: visible;
                            margin-left: 10px;
                            margin-top: 5px;
                          "
                        >
                          {{ file.name }}
                        </span>

                        <img
                          src="assets/icons/trash.svg"
                          alt="trash"
                          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
                          (click)="removeNewFile(i, 'fin_recent_audit_attach')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="!mt-[31px] !mb-[19px] container p-5 !pl-0 !pt-0 !pb-0 !pr-[6.2rem]"
              >
                <div class="rounded p-10 !pl-0 !pb-0 !pt-0 !max-w-[1195px]">
                  <div
                    class="long-section !p-12 !text-[#21252A] !pb-0 !pt-0 items-center !w-full !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2"
                  >
                    <label>
                      Have you experienced any financial difficulties in the
                      last five (5) years
                      <br />(e.g., insolvency, administration)?
                    </label>

                    <mat-radio-group
                      formControlName="has_faced_financial_difficulty"
                      aria-label="Health and Safety Policy"
                      class="flex gap-4 justify-end !text-[#21252A]"
                    >
                      <mat-radio-button value="1">Yes</mat-radio-button>
                      <mat-radio-button value="0">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>

            <h3
              class="!text-[20px] !font-semibold !text-[#21252A] !mb-[0px] !pt-[12px] !pb-[22px]"
            >
              Insurance Cover
            </h3>
            <div
              class="grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container p-0 !pl-0 !pt-0 !pb-[5xp]">
                <div class="rounded p-10 !pb-0 pl-0 !pt-0">
                  <div
                    class="!p-10 !pb-0 !pt-0 !text-[#21252A] !pl-0 flex items-center !w-full grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1"
                  >
                    <label>
                      Provide evidence of the following insurance policies:
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <h3
              class="!text-[18px] !font-semibold !mb-[0px] !pt-[20px] !pb-[22px] !text-[#21252A]"
            >
              Employer's Liability Insurance
            </h3>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 !gap-x-[10rem] container"
            >
              <div class="container p-5 !pt-0 !pl-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pl-0 !pt-0 mb-[40px]">
                  <mat-form-field
                    class="lg:!w-[26.343vw] md:!w-full !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Limit </mat-label>
                    <input
                      matInput
                      formControlName="insurance_employer_limit"
                      placeholder="Limit"
                      currencyMask
                      [options]="{
                        prefix: currencySymbol ? currencySymbol : '$',
                        thousands: ',',
                        decimal: '',
                        nullable: true,
                        allowZero: false,
                        precision: 0,
                        max: 100000000000,
                      }"
                    />
                  </mat-form-field>
                </div>
                <div
                  *ngIf="formGroup.get('insurance_employer_limit')?.value"
                  class="mt-[15px] justify-items-center"
                >
                  <span class="w-full text-[12px] mt-[8px]">
                    {{
                      numberToWords(
                        formGroup.get("insurance_employer_limit")?.value
                      ) | titlecase
                    }}
                  </span>
                </div>
              </div>
              <div class="container p-5 !pt-0 !pl-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pl-0 !pt-0 !mb-[40px]">
                  <mat-form-field
                    class="lg:!w-[26.343vw] md:!w-full !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Expiry Date </mat-label>
                    <input
                      [matDatepicker]="emp_exp"
                      matInput
                      formControlName="insurance_employer_expiry_date"
                      placeholder="Expiry Date"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="emp_exp"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #emp_exp startView="year"></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <h3
              class="!text-[18px] !font-semibold !mb-[0px] !pt-[0px] !pb-[22px] !text-[#21252A]"
            >
              Public Liability Insurance
            </h3>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-[10rem] container"
            >
              <div class="container p-5 !pl-0 !pt-0 !pb-0">
                <div class="rounded p-10 !pl-0 !pb-0 !pt-0 !mb-[40px]">
                  <mat-form-field
                    class="lg:!w-[26.343vw] md:!w-full !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Limit </mat-label>
                    <input
                      matInput
                      formControlName="insurance_public_liability_limit"
                      placeholder="Limit"
                      currencyMask
                      [options]="{
                        prefix: currencySymbol ? currencySymbol : '$',
                        thousands: ',',
                        decimal: '',
                        nullable: true,
                        allowZero: false,
                        precision: 0,
                        max: 100000000000,
                      }"
                    />
                  </mat-form-field>
                </div>
                <div class="mt-[15px] justify-items-center">
                  <span class="w-full text-[12px] mt-[8px]">
                    {{
                      numberToWords(
                        formGroup.get("insurance_public_liability_limit")?.value
                      ) | titlecase
                    }}
                  </span>
                </div>
              </div>
              <div class="container p-5 !pl-0 !pt-0 !pb-0">
                <div class="rounded p-10 !pl-0 !pb-0 !pt-0 !mb-[40px]">
                  <mat-form-field
                    class="lg:!w-[26.343vw] md:!w-full !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Expiry Date </mat-label>
                    <input
                      [matDatepicker]="pub_exp"
                      matInput
                      formControlName="insurance_public_liability_expiry_date"
                      placeholder="Expiry Date"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="pub_exp"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pub_exp startView="year"></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <h3
              class="!text-[18px] !font-semibold !mb-[0px] !pt-[0px] !pb-[22px] !text-[#21252A]"
            >
              Professional Indemnity Insurance
            </h3>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-[10rem] container"
            >
              <div class="container p-5 !pl-0 !pt-0 !pb-0">
                <div class="rounded p-10 !pl-0 !pb-0 !pt-0 !mb-[40px]">
                  <mat-form-field
                    class="lg:!w-[26.343vw] md:!w-full !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Limit </mat-label>
                    <input
                      matInput
                      formControlName="insurance_professional_indemnity_limit"
                      placeholder="Limit"
                      currencyMask
                      [options]="{
                        prefix: currencySymbol ? currencySymbol : '$',
                        thousands: ',',
                        decimal: '',
                        nullable: true,
                        allowZero: false,
                        precision: 0,
                        max: 100000000000,
                      }"
                    />
                  </mat-form-field>
                </div>
                <div class="mt-[15px] justify-items-center">
                  <span class="w-full text-[12px] mt-[8px]">
                    {{
                      numberToWords(
                        formGroup.get("insurance_professional_indemnity_limit")
                          ?.value
                      ) | titlecase
                    }}
                  </span>
                </div>
              </div>
              <div class="container p-5 !pl-0 !pt-0 !pb-0">
                <div class="rounded p-10 !pl-0 !pb-0 !pt-0 !mb-[40px]">
                  <mat-form-field
                    class="lg:!w-[26.343vw] md:!w-full !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Expiry Date </mat-label>
                    <input
                      [matDatepicker]="pro_exp"
                      matInput
                      formControlName="insurance_professional_indemnity_expiry_date"
                      placeholder="Expiry Date"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="pro_exp"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pro_exp startView="year"></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <h3
              class="!text-[18px] !font-semibold !mb-[0px] !pt-[0px] !pb-[22px] !text-[#21252A]"
            >
              Contract Works Insurance (if applicable)
            </h3>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-[10rem] container"
            >
              <div class="container p-5 !pl-0 !pt-0 !pb-0">
                <div class="rounded p-10 !pl-0 !pt-0 !pb-5 ">
                  <mat-form-field
                    class="lg:!w-[26.343vw] md:!w-full !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Limit </mat-label>
                    <input
                      matInput
                      formControlName="insurance_contract_works_limit"
                      placeholder="Limit"
                      currencyMask
                      [options]="{
                        prefix: currencySymbol ? currencySymbol : '$',
                        thousands: ',',
                        decimal: '',
                        nullable: true,
                        allowZero: false,
                        precision: 0,
                        max: 100000000000,
                      }"
                    />
                  </mat-form-field>
                </div>
                <div class="justify-items-center">
                  <span class="w-full text-[12px]">
                    {{
                      numberToWords(
                        formGroup.get("insurance_contract_works_limit")?.value
                      ) | titlecase
                    }}
                  </span>
                </div>
              </div>
              <div class="container p-5 !pl-0 !pt-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pl-0 !pt-0 !mb-[40px]">
                  <mat-form-field
                    class="lg:!w-[26.343vw] md:!w-full !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Expiry Date </mat-label>
                    <input
                      [matDatepicker]="contract_exp"
                      matInput
                      formControlName="insurance_contract_works_expiry_date"
                      placeholder="Expiry Date"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="contract_exp"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #contract_exp
                      startView="year"
                    ></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
         
          </div>
        </div>
        <div class="col-span-full w-[87%]">
          <app-file-manager
            [IsDragNDrop]="true"
            [newFileControlName]="'insuranceFileControl'"
            (newFilesUpdatedEvent)="handleNewFiles($event)"
            [oldFiles]="oldInsuranceFiles"
            (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
          ></app-file-manager>
        </div>
      </ng-container>
    </div>
  </div>
</form>
